import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { textSObj, textXSObj } = typographyStyles;

export const wrapperCss: CSSObject = {
  display: "block",
  marginBottom: "1em",
  marginInline: "0",
  padding: 0,
  width: "auto",
  border: "none",
};

export const legendCss: CSSObject = {
  ...textSObj,
  fontWeight: 700,
  color: ui.neutral[700],

  span: {
    ...textXSObj,
    color: ui.neutral[500],
  },
};

export const toggleButtonCss: CSSObject = {
  display: "flex",
  marginTop: "1em",
  padding: "0",
  gap: "1em",
};

export const toggleLabelCss = (isSelected: boolean): CSSObject => {
  return {
    color: isSelected ? ui.neutral[700] : ui.neutral[500],
  };
};
